<span *ngIf="comment && comment.id && comment.readUserName && comment.readDateTime " id="comment-readed-by{{ comment.id }}" class="text-read-by">
  Lido por {{ comment.readUserName }}
  <br />
  {{ comment.readDateTime | replace:'-':'/' | date:'dd/MM/yyyy' }}
</span>